/**
 * emailDeliveryProcessingHealthApi
 *
 * DASH-EMAIL-009: client for the real, read-only CHECKPOINT-grain
 * Dashboard API (`GET /api/email-delivery/dashboard/processing-health`).
 *
 * Distinct entity grain from emailDeliveryDashboardApi.js's MESSAGE-grain
 * `/summary` endpoint and emailDeliveryRecipientHealthApi.js's
 * RECIPIENT-grain `/recipient-health` endpoint -- this module must never
 * be used to fetch or substitute for a message- or recipient-level metric,
 * and those two clients must never be used for processing/discovery
 * health. See email_delivery_processing_health_service.py's own docstring
 * for the canonical-source rule this pairing enforces.
 *
 * Wraps the SAME shared `api` axios instance every other real-backed War
 * Room surface already uses (see lib/api.js, emailDeliveryDashboardApi.js,
 * emailDeliveryRecipientHealthApi.js) -- no second HTTP stack, no
 * collection name ever appears here or in any caller. Auth (Bearer token)
 * and account scoping (X-Account-ID header) are attached automatically by
 * that instance's own request interceptor; this module never accepts or
 * forwards a caller-supplied account/tenant/location id of any kind --
 * this endpoint takes no query parameters at all.
 *
 * Response shape (DASH-EMAIL-025): {sources: [{ghl_location_id,
 * environment: "qualification"|"production"|null, status:
 * "HEALTHY"|"FAILED"|"UNKNOWN", last_success_at, last_error}, ...],
 * generated_at}. `sources` has one entry per real discovery-source
 * checkpoint the tenant actually has (zero, one, or more -- a tenant with
 * both Qualification and Production discovery active now has two, see
 * email_delivery_processing_health_service.py's own docstring for why a
 * single flat status is no longer a safe representation). Never the raw
 * checkpoint document, never any `_last_run` operational counter -- see
 * useEmailDashboardData.js for how each entry is mapped to
 * EmailHealthCard.jsx's own (lowercase) status vocabulary.
 */
import { api } from "./api";

export async function getEmailDeliveryProcessingHealth() {
  const res = await api.get("/email-delivery/dashboard/processing-health");
  return res.data;
}

export default getEmailDeliveryProcessingHealth;
